import { save as comm_save } from "./comm";

const TEXT = 0,
  CHECK = 1,
  OPTIONS = 2,
  LIST_TYPE = 3;
// FILE = 4;

export function deleteComment(check_id, user_id, main_context, history) {
  return comm_save(
    "/api/inspections/comment/" + check_id + "/delete",
    {},
    user_id,
    main_context,
    history,
    null,
    30
  );
}

/* Save a single comment and photo */

export function saveTextCommentAndPhoto(
  type,
  originalInspection,
  inspection_maintainer,
  comment,
  photo,
  id,
  inspectionId,
  user_id,
  update_main_context,
  history,
  ident
) {
  const postData = {
    checks: {},
    photos: {} /* Only applies to single value equipment checks. */,
    date: originalInspection.date,
    inspection_complete: originalInspection.inspection_complete,
    inspection_maintainer: inspection_maintainer,
    inspectionId,
  };

  /* use bracket notation so "id" is evaluated (and not treated as a
   * string, "id"). Use array syntax to match expected format on server
   * side. */

  postData.checks[id] = [{ comment: comment }];

  /* Ajax should only save 1 comment at a time (server side cannot accept
   * multiple free-form text comments submitted at one time). */

  postData.photos[id] = photo;

  return finalSave(
    postData,
    type,
    originalInspection,
    user_id,
    update_main_context,
    history,
    ident
  );
}

function finalSave(
  postData,
  type,
  originalInspection,
  user_id,
  update_main_context,
  history,
  ident
) {
  return getGeoLocation().then(function (position) {
    if (position && position.coords) {
      postData.geolocation = [
        position.coords.latitude,
        position.coords.longitude,
      ];
    }

    return comm_save(
      "/api/inspections/" +
        type +
        "/" +
        originalInspection.equipment.id +
        "/" +
        originalInspection.operationId +
        "/save",
      postData,
      user_id,
      update_main_context,
      history,
      ident,
      postData.inspection_complete ? 40 : 20
    );
  });
}

function getGeoLocation() {
  return new Promise((resolve) => {
    if ("geolocation" in navigator) {
      /* geolocation is available */
      const options = {
        maximumAge: 0,
        timeout: 5000,
        enableHighAccuracy: true,
      };
      navigator.geolocation.getCurrentPosition(
        function (position) {
          resolve(position);
        },
        function (error) {
          console.warn("getCurrentPosition returned " + error);
          resolve(null);
        },
        options
      );
    } else {
      // geolocation is not available. quietly ignore.
      resolve(null);
    }
  });
}

export function save(
  type,
  user_id,
  update_main_context,
  history,
  originalInspection,
  inspection_maintainer,
  inspectionId
) {
  const data = {
    checks: {},
    photos: {},
    date: originalInspection.date,
    inspection_complete: originalInspection.inspection_complete,
    inspection_maintainer: inspection_maintainer,
    inspectionId,
  };

  iterateActiveLeaves(originalInspection.checks, function (item) {
    /* List types are submitted via one-at-atime via Ajax and should
     * NOT be submitted with Next button/save() */

    if (+item.type !== LIST_TYPE) {
      /* If an item has a value, we submit to the server. */
      data.checks[item.id] = item.value;
      if (item.photo) {
        data.photos[item.id] = item.photo;
      }
    }
  });

  return finalSave(
    data,
    type,
    originalInspection,
    user_id,
    update_main_context,
    history
  );
}

function iterateActiveLeaves(steps, cb) {
  steps.forEach(function (step) {
    const valObj = getValueObject(step);

    if (isValueSet(step.value)) {
      if (valObj && valObj.children && valObj.children.length) {
        iterateActiveLeaves((valObj && valObj.children) || [], cb);
      } else {
        cb(step, valObj);
      }
    }
  });
}

function isValueSet(checkValue) {
  return checkValue && !(Array.isArray(checkValue) && checkValue.length === 0);
}

function getValueObject(item) {
  switch (item.type) {
    case OPTIONS:
      let value = null;
      item.options.forEach(function (option) {
        if ("" + option.value === "" + item.value) {
          value = option;
          return false;
        }
      });
      return value;
    case CHECK:
    case TEXT:
    case LIST_TYPE:
    default:
      return item;
  }
}
